export const TWO_WAY_EXTERNAL_CALENDAR_SOURCES = [
  'advancedmd',
  'allscripts',
  'athena',
  'd-athena',
  'd-primesuite',
  'drchrono',
  'greenway'
]

// The values correspond to the field 'is_telehealth' on the backend api
export const VISIT_TYPE_IN_PERSON_VALUE = 'no'
export const VISIT_TYPE_VIRTUAL_VISIT_VALUE = 'yes'

// Values for block.availability type, copied from CalendarBlockAvailability
export const AVAILABILITY_TYPE_IN_OFFICE_ONLY = 0
export const AVAILABILITY_TYPE_VIRTUAL_ONLY = 1
export const AVAILABILITY_TYPE_IN_OFFICE_OR_VIRTUAL = 2

export const REFERRER_BACK_BUTTON = 'back-button'
export const REFERRER_CLOSE_BUTTON = 'close-button'

export const NO_INSURANCE_OPTION_ID = 700
export const OTHER_INSURANCE_OPTION_ID = 701

export const CALENDAR_GROUPS = {
  A: 'A', // no screening questions, and no appointmentTypeComplexity (reasons with doctorId or locationId or both)
  B: 'B', // has screening questions, and no appointmentTypeComplexity  (reasons with doctorId or locationId or both)
  C: 'C' //  require search before showing times
}

export const CALENDAR_TYPES = {
  PROVIDER_TYPE: 'provider',
  LOCATION_TYPE: 'location',
  PRACTICE_TYPE: 'practice',
  PROVIDER_LOCATION_TYPE: 'provider_location'
}
export const PATIENT_TYPES = {
  NEW: 'new',
  RETURNING: 'returning'
}

export const NOCALENDAR_STATUS = 'nocalendar'

export const FILTER_VALUE_TO_SCREENING_VALUE_MAP = {
  [VISIT_TYPE_IN_PERSON_VALUE]: 0,
  [VISIT_TYPE_VIRTUAL_VISIT_VALUE]: 1
}

export const AVAILABILITY_AS_TYPES = {
  SELF: 'self',
  PRACTICE: 'practice',
  CALENDAR: 'calendar'
}

export const APPT_FEE_PARAGRAPH = 'You’ve selected an appointment that has a required fee of'

// Minimum age required to create an appointment
export const MIN_AGE_REQUIRED = 13
